import { Dropdown } from 'j-comps'
import config from '../../../config'
import MenuIcon from '@mui/icons-material/Menu'

const SettingsDropdown = () => (
  <Dropdown
    appName={config.app}
    dropdownButton={{ icon: <MenuIcon />, text: 'Settings' }}
    firstItem={{ text: config.vendor.name.titleCase }}
    externalLinks={config.settingsLinks}
  />
)

export default SettingsDropdown
